import { FC, ReactNode } from 'react';
import Typography from '@components/common/typography';
import styles from './page_header.module.scss';

interface IProps {
    title: string;
    subtitle?: string;
    eyebrow?: string;
    actions?: ReactNode;
}

const DevPageHeader: FC<IProps> = ({ title, subtitle, eyebrow, actions }) => (
    <div className={styles.header}>
        <div className={styles.text}>
            {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
            <Typography variant="h4" weight="semibold" className={styles.title}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="body3" className={styles.subtitle}>
                    {subtitle}
                </Typography>
            )}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
    </div>
);

export default DevPageHeader;
